import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "mt-1" }
const _hoisted_3 = { class: "property" }
const _hoisted_4 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = {
  key: 0,
  class: "second-section-grid"
}
const _hoisted_7 = { class: "property" }

import ModalMap from '@/components/maps/ModalMap.vue'
import { AlarmAISData, Coordinate } from '@/server/MakeSenseApp-backend'
import { onMounted, ref } from 'vue'
import CoordinateCell from '../cells/CoordinateCell.vue'
import KpCell from '../cells/KpCell.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AisDataProperties',
  props: {
  data: AlarmAISData,
  kp: Number,
  coordinate: Coordinate
},
  setup(__props) {

var firstSection = ref<{ name: string; value: string }[]>([])
var secondSection = ref<{ name: string; value: string }[]>([])

var props = __props

onMounted(() => {
  firstSection.value = [
    { name: 'Vessel:', value: props.data?.vesselName ?? '-' },
    { name: 'Zone:', value: props.data?.zone ?? '-' }
  ]

  secondSection.value = [
    { name: 'Rule Group:', value: props.data?.ruleGroup ?? '-' },
    { name: 'MMSI:', value: props.data?.mmsi?.toString() ?? '-' },
    { name: 'Length, Breadth:', value: props.data?.length + ', ' + props.data?.breadth },
    { name: 'Destination:', value: props.data?.destination ?? '-' },

    { name: 'Speed over ground:', value: props.data?.speedOverGround?.toFixed(2) ?? '-' },
    { name: 'Course over ground:', value: props.data?.courseOverGround?.toFixed(2) ?? '-' },
    { name: 'Radio call sign:', value: props.data?.radioCallSign ?? '-' }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.data?.vessel)
      ? (_openBlock(), _createBlock(ModalMap, {
          key: 0,
          vessel: __props.data?.vessel,
          class: "map"
        }, null, 8, ["vessel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(KpCell, {
        style: {"margin-right":"14px"},
        kp: __props.kp
      }, null, 8, ["kp"]),
      _createVNode(CoordinateCell, {
        coordinates: [__props.coordinate?.latitude ?? 0, __props.coordinate?.longitude ?? 0]
      }, null, 8, ["coordinates"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firstSection), (property, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(property.name), 1),
          _createTextVNode(" " + _toDisplayString(property.value), 1)
        ]))
      }), 128))
    ]),
    (__props.data?.comment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "property comment" }, "Comment:", -1)),
          _createTextVNode(" " + _toDisplayString(__props.data?.comment), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_unref(secondSection).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(secondSection), (property, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "property-item"
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(property.name), 1),
                _createTextVNode(" " + _toDisplayString(property.value), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})